/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import { MonoPhasicForm, BiPhasicForm, TriPhasicForm } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { postForm } from 'js/actions/formsAction';

export default function MaterialTableDemo(props) {
  const dispatch = useDispatch();
  const comunicationStepForm = useSelector((state) => state.forms.data[1]);
  const { chargeType, concentratorPhase } = comunicationStepForm;
  const { nextStep, prevStep } = props;

  const onSubmit = (values) => {
    dispatch(postForm(values));
  };

  const getPhaseData = (chargeType, concentratorPhase) => {
    switch (chargeType) {
      case 'MONOFASICA':
        return (
          <MonoPhasicForm
            concentrator={concentratorPhase}
            nextStep={nextStep}
            prevStep={prevStep}
          ></MonoPhasicForm>
        );

      case 'BIFASICA':
        return (
          <BiPhasicForm
            concentrator={concentratorPhase}
            nextStep={nextStep}
            prevStep={prevStep}
          ></BiPhasicForm>
        );

      case 'TRIFASICA':
        return (
          <TriPhasicForm
            concentrator={concentratorPhase}
            nextStep={nextStep}
            prevStep={prevStep}
          ></TriPhasicForm>
        );
    }
  };

  return <div>{getPhaseData(chargeType, concentratorPhase)}</div>;
}
